import React from 'react';
import CommunityAndPolicyTemplate from '@templates/CommunityAndPolicy';

export default function CommunityAndPolicy() {
  return (
    <CommunityAndPolicyTemplate
      title="Community And Policy"
      h1="Community & Policy"
    />
  );
}
